import { registerServiceWorker as register } from "@bindery/ui/lib/register-service-worker";
import { logging } from "./logging/backend";
import { toError } from "./logging/earlyErrorCapture";

export function registerServiceWorker(): void {
  register({
    url: "/sw.js",
    enabled: import.meta.env.PROD,
    log: () => {
      const log = logging.createClientLogger();
      return {
        event: (name, fields) => log.event(name, fields),
        error: (name, cause, fields) =>
          log.error(
            name,
            toError(cause, "service worker registration failed"),
            fields,
          ),
      };
    },
  });
}
